// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1ft98","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2gCz1"};